module.exports = __webpack_public_path__ + "img/black-logo.3fde6b06.svg";